module.exports = __webpack_public_path__ + "img/vertical_3_3_6005.aeaa8951.png";